"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValue = defaultValue;
const defineSchema_1 = require("./defineSchema");
const generateGuid_1 = require("../methods/generateGuid");
const now_1 = require("../methods/now");
const today_1 = require("../methods/today");
const IOptions_1 = require("../WrappedProperty/IOptions");
// import { defaultOptions } from '../WrappedProperty/IOptions';
/**
 * Domyślna wartośc na podstawie pól default ze schematu
 * @param schema schemat
 * @param force czy wymusić domyślne wartości dla kazdego pola:
 *  * liczba: `0`
 *  * boolean: `false`
 *  * string: `""`
 *
 */
function defaultValue(schema, force = false, defaultNumber = null, options = IOptions_1.defaultOptions, currentPath = '') {
    var _a;
    let result = null;
    const type = schema.type || (schema.properties && 'object') || (schema.items && 'array') || 'string';
    if ((0, defineSchema_1.isFunction)(schema.default))
        return; //trzeba policzyć podczas wrapowania
    let disabled = false;
    if (schema.disabled !== undefined) {
        disabled = schema.disabled === true || !!((_a = options._disabledFields) === null || _a === void 0 ? void 0 : _a.has(currentPath));
    }
    if (type === 'object') {
        if (schema.default !== undefined) {
            if (schema.default === null) {
                return null;
            }
            else {
                return Object.assign({}, schema.default);
            }
        }
        result = {};
        let isEmpty = true;
        if (schema.properties) {
            const path = currentPath === '' ? currentPath : currentPath + '.';
            for (const key in schema.properties) {
                const element = schema.properties[key];
                const value = defaultValue(element, force, defaultNumber, options, path + key);
                if (value !== undefined) {
                    result[key] = value;
                    isEmpty = false;
                }
            }
        }
        if (!isEmpty || schema.$parent === undefined || force) {
            return result;
        }
    }
    else if (type === 'array') {
        // if (disabled) return [];
        let minLength = 0;
        // let minLength = schema.minItems
        if (schema.default !== undefined) {
            if (typeof schema.default === 'number') {
                minLength = schema.default;
            }
            else {
                return Array.from(schema.default);
            }
        }
        if (schema.length !== undefined && typeof schema.length === 'number') {
            minLength = schema.length;
        }
        result = [];
        let isEmpty = true;
        if (schema.items) {
            if (minLength && !disabled) {
                for (let i = 0; i < minLength; i++) {
                    const value = defaultValue(schema.items, force, defaultNumber, options, currentPath + '[' + i + ']');
                    result.push(value);
                    isEmpty = false;
                }
            }
            else {
                /*
                                                const value = defaultValue(schema.items, force);
                                                if (value !== undefined) {
                                                    result.push(value);
                                                    isEmpty = false;
                                                }
                                                */
            }
        }
        // if (!isEmpty) return result;
        if (!isEmpty || schema.$parent === undefined || force) {
            return result;
        }
    }
    if (schema.default !== undefined) {
        switch (type) {
            case 'string':
                switch (schema.format) {
                    case 'date':
                        switch (schema.default) {
                            case 'today':
                            case 'now':
                                return (0, today_1.today)();
                        }
                        break;
                    case 'date-time':
                        switch (schema.default) {
                            case 'today':
                                return (0, today_1.today)() + ' 00:00:00';
                            case 'now':
                                return (0, now_1.now)();
                        }
                        break;
                    case 'guid':
                    case 'guidshort':
                    case 'guidlong':
                        switch (schema.default) {
                            case 'generate':
                            case 'new':
                                return (options === null || options === void 0 ? void 0 : options.longGuids) || schema.format == 'guidlong' ? (0, generateGuid_1.generateGuid)() : (0, generateGuid_1.generateShortGuid)();
                        }
                        break;
                }
        }
        return schema.default;
    }
    if (force) {
        switch (type) {
            case 'number':
            case 'money':
            case 'integer':
                return defaultNumber;
            case 'boolean':
                return false;
            case 'string':
                switch (schema.format) {
                    case 'guid':
                        return (options === null || options === void 0 ? void 0 : options.longGuids) ? (0, generateGuid_1.generateGuid)() : (0, generateGuid_1.generateShortGuid)();
                    case 'guidshort':
                        return (0, generateGuid_1.generateShortGuid)();
                    case 'guidlong':
                        return (0, generateGuid_1.generateGuid)();
                    default:
                        return '';
                }
        }
    }
    // return result;
}
exports.default = defaultValue;
//# sourceMappingURL=defaultValue.js.map